export default __webpack_public_path__ + "static/media/landing-page-head-7.38712088.png";